import React, { useEffect, useState } from "react";
import DTOGovtTax from "./DTOGovtTax";
import GovtTaxPresenter from "./GovtTaxPresenter";
import { aboutMeType } from "../../../../common/interfaces/myProfile/personalDetails/aboutMeType";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";
function GovtTaxController() {
  const { t } = useTranslation();
  const [empGovtTax, setEmpGovtTax] = useState([]);
  const [currency, setCurrency] = useState("");
  const isLoading = useAppSelector(
    (state) => state.salaryLoadersSlice.govtTaxLoader
  );
  function callBackFunc(data: any) {
    setEmpGovtTax(data);
  }

  function getCurrency(data: any) {
    setCurrency(data);
  }
  return (
    <div>
      <DTOGovtTax
        setEmpAssignGovtTaxData={callBackFunc}
        setCurrency={getCurrency}
      />
      <GovtTaxPresenter
        employeeGovtTaxData={empGovtTax}
        currency={currency}
        isLoading={isLoading}
        trans={t}
      />
    </div>
  );
}

export default GovtTaxController;
